<div class="shareholder">
    <div class="row">
        <div class="col-12 ml-auto mr-auto">

            <ng-container *ngIf="!loading">
                <!-- <app-back-button></app-back-button> -->
            </ng-container>

            <div class="shareholder-card">
                <div class="row w-100 no-gutters align-items-start">
                    <div class="col-12 col-lg-8 d-flex flex-row"
                        *ngIf="loading">
                        <div class="shareholder-profile-initials bg-none">
                            <ngx-skeleton-loader appearance="circle" [theme]="{
                                    width: '64px',
                                    height: '64px',
                                    margin:'0'
                                  }">
                            </ngx-skeleton-loader>
                        </div>
                        <app-spacer [right]="32"></app-spacer>
                        <div class="d-flex flex-column">
                            <ngx-skeleton-loader [theme]="{
                                    height: '44px',
                                    width: '500px',
                                    margin:'0'
                                  }">
                            </ngx-skeleton-loader>
                            <div class="d-flex flex-row align-items-center">
                                <ngx-skeleton-loader [theme]="{
                                    height: '24px',
                                    width:'150px'
                                }"></ngx-skeleton-loader>
                            </div>
                        </div>
                    </div>

                    <div class="col-12 col-lg-8 d-flex flex-row"
                        *ngIf="!loading">
                        <div class="shareholder-profile-initials">
                            <span>
                                {{fund.name ? getInitials(fund.name) : '0*'}}
                            </span>
                        </div>
                        <app-spacer [right]="32"></app-spacer>
                        <div class="d-flex flex-column">
                            <span class="shareholder-profile-name">
                                {{fund.name ?? '0*'}}
                            </span>
                            <div class="d-flex flex-row align-items-center">
                                <span class="shareholder-profile-type">
                                    {{getChoicesName('cvm_classification_choices',
                                    fund.cvm_classification)?.label}}
                                </span>
                            </div>
                            <div class="d-flex mt-2">
                                <app-badge [approval]="approval"
                                    [fund]="fund"></app-badge>
                            </div>
                        </div>
                    </div>

                    <div class="col-12 col-lg-4 d-flex justify-content-end align-items-start">
                        <ng-container *ngIf="loading">
                            <ngx-skeleton-loader [theme]="{
                            height: '44px',
                            width: '139px',
                            margin:'0'
                          }">
                            </ngx-skeleton-loader>
                        </ng-container>

                        <ng-container *ngIf="!loading">

                            <app-tooltip *ngIf="isInApproval()"
                                text="Fundo em fase de aprovação"
                                [position]="'top'" [zIndex]="1">
                                <div style="display: inline-block;">
                                    <app-button [outline]="true"
                                        [disabled]="true">
                                        Editar
                                    </app-button>
                                </div>
                            </app-tooltip>

                            <app-button *ngIf="!isInApproval()"
                                (onClick)="rediretToEdit()" [outline]="true">
                                Editar
                            </app-button>

                            <app-spacer [right]="8"></app-spacer>

                            <ng-container *ngIf="!approval.completed">
                                <app-button-with-dropdown #approveButtonDropdown
                                    label="Aprovar fundo"
                                    (toggleShowOptions)="toggleShowOptions()"
                                    (onClick)="handleApproval(true); $event.stopPropagation()"
                                    [showOptions]="showCtaOptions"
                                    [disabled]="isApproveDisabled()">
                                    <button class="dropdown-button"
                                        style="color:var(--danger)"
                                        (click)="$event.stopPropagation(); handleApproval(false,true)">
                                        Retornar
                                    </button>
                                    <button class="dropdown-button"
                                        style="color:var(--danger)"
                                        (click)="$event.stopPropagation(); handleApproval(false)">
                                        Rejeitar
                                    </button>
                                    <ng-container
                                        *ngTemplateOutlet="operationalDropdownActions">
                                    </ng-container>
                                </app-button-with-dropdown>
                            </ng-container>

                            <ng-container
                                *ngIf="!approval.completed && isApproveDisabled() && hasScheduleActions()">
                                <app-spacer [right]="8"></app-spacer>
                                <app-button-with-dropdown
                                    label="Ações"
                                    [outline]="true"
                                    [showOptions]="showOperationalOptions"
                                    (toggleShowOptions)="toggleOperationalOptions($event)"
                                    (onClick)="toggleOperationalOptions($event)">
                                    <ng-container
                                        *ngTemplateOutlet="operationalDropdownActions">
                                    </ng-container>
                                </app-button-with-dropdown>
                            </ng-container>

                            <ng-container
                                *ngIf="approval.completed && permissionObj.canChange && hasScheduleActions()">
                                <app-button-with-dropdown
                                    label="Ações"
                                    [outline]="true"
                                    [showOptions]="showOperationalOptions"
                                    (toggleShowOptions)="toggleOperationalOptions($event)"
                                    (onClick)="toggleOperationalOptions($event)">
                                    <ng-container
                                        *ngTemplateOutlet="operationalDropdownActions">
                                    </ng-container>
                                </app-button-with-dropdown>
                            </ng-container>

                            <ng-container
                                *ngIf="approval.completed && permissionObj.canChange && !hasScheduleActions()">
                                <app-button
                                    *ngIf="canInactivateFund() || canReactivateFund()"
                                    (onClick)="openFundOperationalModal($event)"
                                    [danger]="canInactivateFund()">
                                    {{ canInactivateFund() ? 'Inativar fundo' : 'Solicitar reativação' }}
                                </app-button>
                            </ng-container>
                        </ng-container>
                    </div>
                </div>
            </div>
            <app-spacer [bottom]="24"></app-spacer>

            <ng-container *ngIf="loading">
                <ngx-skeleton-loader [theme]="{
                height: '140px',
                width: '100%',
                margin:'0'
              }">
                </ngx-skeleton-loader>
            </ng-container>

            <ng-container *ngIf="!loading">
                <app-approvation-steps
                    [approval]="approval"></app-approvation-steps>
            </ng-container>

            <app-spacer [bottom]="60"></app-spacer>

            <div class="d-flex">
                <app-spacer [left]="20"></app-spacer>
                <app-tabs [tabs]="tabs" (onChangeTab)="onChangeTab($event)"
                    [currentTab]="tabIndex" [dashboardTab]="true">
                </app-tabs>
            </div>

            <app-spacer [bottom]="24"></app-spacer>

            <div *ngIf="activedTab === 'basic_data'">
                <app-dashboard-fund-approval-basic [isLoading]="loading">
                </app-dashboard-fund-approval-basic>
            </div>

            <ng-container *ngIf="!loading">
                <div *ngIf="activedTab === 'transfer'">
                    <app-dashboard-fund-approval-transfers
                        [canChange]="permissionObj.canChange"
                        [refreshKey]="transfersRefreshKey"
                        (edit)="onEditTransfer($event)"
                        (cancel)="onCancelTransfer($event)"
                        (confirm)="onConfirmTransfer($event)">
                    </app-dashboard-fund-approval-transfers>
                </div>

                <div *ngIf="activedTab === 'complementary'">
                    <app-dashboard-fund-approval-complementary>
                    </app-dashboard-fund-approval-complementary>
                </div>

                <div *ngIf="activedTab === 'quote'">
                    <app-dashboard-fund-approval-quotas>
                    </app-dashboard-fund-approval-quotas>
                </div>



                <div *ngIf="activedTab === 'tax'">
                    <app-dashboard-fund-approval-tax>
                    </app-dashboard-fund-approval-tax>
                </div>

                <div *ngIf="activedTab === 'bank'">
                    <app-dashboard-fund-approval-banking>
                    </app-dashboard-fund-approval-banking>
                </div>

                <div *ngIf="activedTab === 'drafts'">
                    <app-dashboard-fund-approval-drafts>
                    </app-dashboard-fund-approval-drafts>
                </div>

                <div *ngIf="activedTab === 'documents'">
                    <app-dashboard-fund-approval-documents>
                    </app-dashboard-fund-approval-documents>
                </div>

                <!-- <div *ngIf="activedTab === 'attachments'">
                    <app-dashboard-fund-approval-attachments>
                    </app-dashboard-fund-approval-attachments>
                </div> -->

                <div *ngIf="activedTab === 'shareholder'">
                    <app-dashboard-fund-approval-shareholder>
                    </app-dashboard-fund-approval-shareholder>
                </div>

                <div *ngIf="activedTab === 'assignors'">
                    <app-dashboard-fund-approval-assignor>
                    </app-dashboard-fund-approval-assignor>
                </div>

                <div *ngIf="activedTab === 'provider'">
                    <app-dashboard-fund-approval-providers>
                    </app-dashboard-fund-approval-providers>
                </div>
            </ng-container>
        </div>
    </div>


    <app-warning-modal [active]="warningModal" *ngIf="!loading">
        <h3>Atenção</h3>
        <app-spacer [bottom]="24"></app-spacer>

        <ng-container *ngIf="approve && !resetApproval">
            <p>
                Você tem certeza que deseja aprovar o cadastro de
                {{approval.fund.fantasy_name}}
            </p>
            <app-spacer [bottom]="56"></app-spacer>

            <app-button (onClick)="closeWarningModal()" [center]="true"
                [danger]="true" [disabled]="signing">
                Cancelar
            </app-button>
            <app-spacer [bottom]="8"></app-spacer>
            <app-button (onClick)="signApproval(approve)" [center]="true"
                class="add-button" [loading]="signing">
                Sim, quero aprovar
            </app-button>
        </ng-container>

        <ng-container *ngIf="!approve && !resetApproval">
            <form [formGroup]="reproveForm">
                <p>
                    Você tem certeza que deseja reprovar o fundo
                    {{approval.fund.fantasy_name}}
                </p>
                <app-spacer [bottom]="16"></app-spacer>
                <app-input type="textarea" [group]="reproveForm"
                    controlName="description" [rows]="4"
                    label="Esclareça o motivo da reprovação" [noResize]="true">
                </app-input>
                <app-spacer [bottom]="56"></app-spacer>

                <app-button (onClick)="closeWarningModal()" [center]="true"
                    [disabled]="signing" class="add-button">
                    Cancelar
                </app-button>
                <app-spacer [bottom]="8"></app-spacer>
                <app-button (onClick)="signApproval(approve)" [center]="true"
                    [loading]="signing" [danger]="true"
                    [disabled]="this.reproveForm.invalid">
                    Sim, quero reprovar
                </app-button>
            </form>
        </ng-container>

        <ng-container *ngIf="resetApproval">
            <form [formGroup]="reproveForm">
                <p>
                    Você tem certeza que deseja retornar o fundo
                    {{approval.fund.fantasy_name}}
                </p>
                <app-spacer [bottom]="16"></app-spacer>
                <app-input type="textarea" [group]="reproveForm"
                    controlName="description" [rows]="4"
                    label="Esclareça o motivo do retorno" [noResize]="true">
                </app-input>
                <app-spacer [bottom]="56"></app-spacer>

                <app-button (onClick)="closeWarningModal()" [center]="true"
                    [disabled]="signing" class="add-button">
                    Cancelar
                </app-button>
                <app-spacer [bottom]="8"></app-spacer>


                <app-button (onClick)="signApproval(approve)" [center]="true"
                    [loading]="signing" [danger]="true"
                    [disabled]="this.reproveForm.invalid">
                    Sim, quero retornar
                </app-button>
            </form>
        </ng-container>

    </app-warning-modal>
    <app-fund-operational-status-modal [fund]="fund"
        [mode]="fundOperationalModalMode"
        [prefill]="fundOperationalPrefill"
        (closed)="closeFundOperationalModal()"
        (statusChanged)="onFundOperationalStatusChanged()">
    </app-fund-operational-status-modal>
    <app-carbon-warning-modal [active]="showCancelScheduleModal"
        title="Cancelar agendamento"
        message="Tem certeza que deseja cancelar o agendamento de inativação deste fundo?"
        confirmText="Sim, cancelar" cancelText="Não, manter agendamento"
        [loading]="scheduleActionLoading"
        loadingText="Cancelando agendamento..."
        loadingConfirmText="Cancelando..."
        [skipAutoCloseOnConfirm]="true"
        [confirmAction]="confirmCancelSchedule.bind(this)"
        [cancelAction]="closeCancelScheduleModal.bind(this)"
        (onClose)="closeCancelScheduleModal()">
    </app-carbon-warning-modal>
    <app-carbon-warning-modal [active]="showConfirmInactivationModal"
        title="Atenção"
        message="Esta ação <strong>não poderá ser desfeita</strong>. O fundo será <strong>inativado imediatamente</strong>, junto com os cedentes e cotistas vinculados."
        confirmText="Confirmar inativação" cancelText="Cancelar"
        [loading]="scheduleActionLoading"
        loadingText="Inativando fundo..."
        loadingConfirmText="Inativando..."
        [skipAutoCloseOnConfirm]="true"
        [confirmAction]="confirmScheduledInactivation.bind(this)"
        [cancelAction]="closeConfirmInactivationModal.bind(this)"
        (onClose)="closeConfirmInactivationModal()">
    </app-carbon-warning-modal>
    <app-loading-spinner [active]="signing"></app-loading-spinner>

    <ng-template #operationalDropdownActions>
        <button type="button" class="dropdown-button"
            *ngIf="canEditScheduledTransfer()"
            (click)="openEditScheduleFromHeader($event)">
            Editar agendamento
        </button>
        <button type="button" class="dropdown-button"
            *ngIf="canCancelScheduledTransfer()"
            (click)="onCancelTransfer(null, $event)">
            Cancelar agendamento
        </button>
        <button type="button" class="dropdown-button"
            *ngIf="canConfirmInactivation()"
            (click)="onConfirmTransfer(null, $event)">
            Confirmar inativação
        </button>
        <button type="button" class="dropdown-button"
            *ngIf="canInactivateFund()"
            style="color:var(--danger)"
            (click)="openFundOperationalModal($event)">
            Inativar fundo
        </button>
        <button type="button" class="dropdown-button"
            *ngIf="canReactivateFund()"
            (click)="openFundOperationalModal($event)">
            Solicitar reativação
        </button>
    </ng-template>
</div>